import React, { useEffect,  useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Offcanvas, Button } from "react-bootstrap";
import PayRollFilterBox from "../../../components/FilterBox/PayRollFilter/PayRollFilter";
import { FiMenu } from "react-icons/fi";
import PayRollTable from "../../../components/Tables/PayRollTable";
import DroupdownFilterBox from "../../../components//FilterBox/PayRollFilter/PayRollDropDownFilter";
import {
  SalaryStatement,
  DeptGrpList,
  SalaryStatementdataFun,
} from "../../../Redux/Slice/PayRoll/PayRollSlice";
import { Loader } from "../../../components/Loader/Loader";
import { useTheme } from "../../../Themecontext/Themecontext";

export const SalaryStateMent = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { SalaryStatementdata, DeptGrpListdata } = useSelector(
    (state) => state.PayRollSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const Firm = Cookies.get("Firm");
  let YearId = Cookies.get("FinancialYear");

  // ================= FILTER STATE =================

  const [filters, setFilters] = useState({
    year: [],
    month: [],
    department: [],
  });

  const [search, setSearch] = useState({
    year: "",
    month: "",
    department: "",
  });


  const [selectedYear, setSelectedYear] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const [selectedYearId, setSelectedYearId] = useState([]);
  const [selectedMonthId, setSelectedMonthId] = useState([]);
  const [selectedDeptId, setSelectedDeptId] = useState([]);

  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    dispatch(SalaryStatementdataFun());
    dispatch(
      DeptGrpList({
        Firm: Firm,
        Year: YearId,
      }),
    );

    dispatch(
      SalaryStatement({
        Firm: Firm,
        Year: YearId,
      }),
    );
  }, [dispatch, Firm, YearId]);

  const formatIndian = (amount) => {
    if (!amount && amount !== 0) return "";
    return Number(amount).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
      }`,
    borderLeft: `6px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
      }`,
    borderRadius: "12px",
    padding: "12px",
    textAlign: "center",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const valueStyle = {
    marginTop: "10px",
    fontWeight: "600",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };

  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];

  // ================= DATA =================

  const yearList =
    DataMain?.AC_Year_List?.map((item) => ({
      label: item?.AcYear,
      value: item?.AcYearID,
    })) || [];

  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.id,
    })) || [];
  const departmentList =
    DeptGrpListdata?.Data?.map((item) => ({
      label: item?.DepartmentGroup,
      value: item?.DeptGroupID,
    })) || [];

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const applyFilter = () => {
    dispatch(SalaryStatementdataFun());

    const finalYearIDs =
      filters.year.length === 0 ? [Cookies.get("FinancialYear")] : filters.year;

    dispatch(
      SalaryStatement({
        Firm: Firm,
        Year: finalYearIDs.join(","),
        MonthIDs: filters.month.join(","),
        DeptGrpIDs: filters.department.join(","),
      }),
    );

    setShowFilter(false)
  };

  const applyFilter1 = () => {
    dispatch(SalaryStatementdataFun());

    const finalYearIDs =
      filters.year.length > 0
        ? filters.year
        : selectedYearId.length > 0
          ? selectedYearId
          : [Cookies.get("FinancialYear")];

    const finalMonthIDs =
      filters.month.length > 0 ? filters.month : selectedMonthId;

    const finalDeptIDs =
      filters.department.length > 0 ? filters.department : selectedDeptId;

    dispatch(
      SalaryStatement({
        Firm: Firm,
        Year: finalYearIDs.join(","),
        MonthIDs: finalMonthIDs.join(","),
        DeptGrpIDs: finalDeptIDs.join(","),
      }),
    );
  };

  const getRows = SalaryStatementdata?.Dtl?.map((label, index) => ({
    // srNumber: index + 1,
    Department: label.DeptGrpName,
    EmplName: label.EmplName,
    PDays: label.PDays,
    TotalSalary: label.TotalSalary,
    PT: label.PT,
    PF: label.PF,
    ESI: label.ESI,
    TotAdd: label.TotAdd,
    TotLess: label.TotLess,
    OtherLess: label.OtherLess,
    OtherEarning: label.OtherEarning,
    NetSalary: label.NetSalary,
  }));

  const getColumns = [
    {
      key: "srNumber",
      label: "Sr No",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "EmplName",
      label: "Employee",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "Department",
      label: "Department",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { key: "NetSalary", label: "Net Salary", format: "true", align: "right" },
    { key: "PDays", label: "Present Day", format: "false", align: "right" },
    {
      key: "TotalSalary",
      label: "Total Salary",
      format: "true",
      align: "right",
    },
    { key: "PT", label: "PT", format: "true", align: "right" },
    { key: "PF", label: "PF", format: "true", align: "right" },
    { key: "ESI", label: "ESI", format: "true", align: "right" },
    { key: "OtherLess", label: "Other Less", format: "true", align: "right" },
    {
      key: "OtherEarning",
      label: "Other Earning",
      format: "true",
      align: "right",
    },
  ];

  if (SalaryStatementdata === null || SalaryStatementdata === "no") {
    return <Loader />;
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <Row className="mb-3 align-items-end">
        <div className="d-lg-none d-flex justify-content-end mb-3">
          <Button
            onClick={handleShow}
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
              border: "none",
              borderRadius: "10px",
              padding: "8px 12px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
            }}

          >
            <FiMenu size={22} />
          </Button>
        </div>
      </Row>

      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
        >
          <Offcanvas.Title
            style={{
              color:
                isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour12,
            }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />

            <PayRollFilterBox
              title="Department"
              items={departmentList}
              search={search.department}
              setSearch={(val) => handleSearch("department", val)}
              selectedItems={filters.department}
              toggleItem={(item) => toggleItem("department", item)}
              selectAll={() => selectAll("department", departmentList)}
            />

            <Button
              onClick={applyFilter}
              style={{
                width: "100%",
                // height: "44px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,

                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                padding: "12px",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Col xl={12} className="d-none d-lg-block">
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
            padding: "15px",
            borderRadius: "12px",
            border: `2px solid ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3
              }`,
            marginBottom: "20px",
          }}
        >
          <Row>
            {/* YEAR */}
            <Col xl={3} lg={6} md={6} sm={12}>
              <DroupdownFilterBox
                label="Year"
                data={yearList}
                selectedValue={selectedYear}
                setSelectedValue={setSelectedYear}
                selectedId={selectedYearId}
                setSelectedId={setSelectedYearId}
                placeholder="Select Year"
                isdark={isdark}
                iscolour={iscolour}
                iscolourDark={iscolourDark}
              />
            </Col>

            {/* MONTH */}
            <Col xl={3} lg={6} md={6} sm={12}>
              <DroupdownFilterBox
                label="Month"
                data={monthList}
                selectedValue={selectedMonth}
                setSelectedValue={setSelectedMonth}
                selectedId={selectedMonthId}
                setSelectedId={setSelectedMonthId}
                placeholder="Select Month"
                isdark={isdark}
                iscolour={iscolour}
                iscolourDark={iscolourDark}
              />
            </Col>

            {/* DEPARTMENT */}
            <Col xl={3} lg={6} md={6} sm={12}>
              <DroupdownFilterBox
                label="Department"
                data={departmentList}
                selectedValue={selectedDept}
                setSelectedValue={setSelectedDept}
                selectedId={selectedDeptId}
                setSelectedId={setSelectedDeptId}
                placeholder="Select Department"
                isdark={isdark}
                iscolour={iscolour}
                iscolourDark={iscolourDark}
              />
            </Col>

            {/* BUTTON */}
            <Col
              xl={3}
              lg={6}
              md={6}
              sm={12}
              style={{ display: "flex", alignItems: "end" }}
            >
              <button
                style={{
                  padding: "12px",
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour12,
                  width: "100%",
                  border: "none",
                  borderRadius: "12px",
                  fontWeight: "700",
                }}
                onClick={applyFilter1}
              >
                Apply Filters
              </button>
            </Col>
          </Row>
        </div>
      </Col>
      {/* SUMMARY */}
      <Row className="g-3">
        <Col xl={6}>
          <div style={cardStyle}>
            <h4 style={valueStyle}>
              {formatIndian(SalaryStatementdata?.Summ[0]?.TotalSalary)}
            </h4>
            <h6 style={titleStyle}>Total Salary</h6>
          </div>
        </Col>

        <Col xl={6}>
          <div style={cardStyle}>
            <h4 style={valueStyle}>
              {SalaryStatementdata?.Summ[0]?.TotalEmpl}
            </h4>
            <h6 style={titleStyle}>Total Employees</h6>
          </div>
        </Col>
      </Row>

      {/* TABLE */}
      <div
        style={{
          marginTop: "25px",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          SALARY STATEMENT
        </div>

        <PayRollTable columns={getColumns} data={getRows} showSearch />
      </div>
    </div>
  );
};
